import { Request } from '@group-devs/yfp7-global-modules'
import { getUrl } from '@group-devs/yfp7-global-modules/utils/general'
import Authenticator from '@group-devs/yfp7-authenticator'

function ensureAuthProps(authProps) {
    if (!authProps || typeof authProps !== 'object') {
        // Return a default auth object with all required properties
        return {
            auth: {
                isAuthenticated: false,
                site_owner: false,
                site_user: false,
                userId: null,
                contactId: null,
            }
        };
    }
    
    // If authProps exists but auth property is missing or not an object
    if (!authProps.auth || typeof authProps.auth !== 'object') {
        authProps.auth = {};
    }
    
    // Ensure all required properties exist with proper defaults
    // ⚠ Update from using || to ?? (nullish coalescing) to avoid overwriting false/0 values
    authProps.auth.isAuthenticated = authProps.auth.isAuthenticated ?? false;
    authProps.auth.site_owner = authProps.auth.site_owner ?? false;
    authProps.auth.site_user = authProps.auth.site_user ?? false;
    authProps.auth.userId = authProps.auth.userId ?? null;
    authProps.auth.contactId = authProps.auth.contactId ?? null;
    
    return authProps;
}

const parseSessionCookie = (cookie) => {
    if (typeof cookie === 'undefined') return null;
    try {
        return JSON.parse(Buffer.from(cookie, 'base64').toString());
    } catch (error) {
        console.error("Error parsing cookie:", error);
        return null;
    }
};

async function initialProps(req, res, query, path = false) {
    let token, cookie, authenticator, request, metaData, authProps, graphProps, pageProps, sitesProps, countryCode, props = {};
    
    try {
        authenticator = new Authenticator(req, res, process.env);
        request = new Request(process.env.apiDomain);
        const sessionName = authenticator.env.AUTH_SERVER_SESSION_NAME;

        // Set CSRF metadata
        metaData = authenticator.setCsrf();

        // Set host and path
        if (typeof req !== "undefined") {
            props.host = req.headers.host;
            // props.path = req.url
        } else {
            props.host = window.location.hostname;
            // props.path = window.location.pathname
        }

        props.path = path ? path : null;
        props.query = query ? query : null;

        // console.log('req:', req.headers);
        // console.log('host:', req.headers.host);

        // set initial authentication cookie
        try {
            token = await authenticator.getToken();
        } catch (tokenError) {
            console.error("Error getting token:", tokenError);
            token = null;
        }

        console.time('parallel-api-calls');
        const [graphPropsResult, countryCodeResult] = await Promise.all([
            request.website.siteData(getUrl(props.host, props.path)),
            request.core.countries({is_active: 1})
        ]);
        console.timeEnd('parallel-api-calls');

        graphProps = graphPropsResult; // initial website data
        countryCode = countryCodeResult; // list of active country list for country code

        // console.log('graphProps:', graphProps);

        console.time('dependent-api-calls');
        const accountId = graphProps.site?.accountId || '';
        const site_id = graphProps.site?.id ? parseInt(graphProps.site.id) : '';

        const dependentCalls = [];
        
        // pageProps
        if (graphProps.site?.site?.code === "WC") {
            dependentCalls.push(request.website.pageData(getUrl(props.host, path)));
        } else {
            dependentCalls.push(Promise.resolve(null));
        }

        // sitesProps - Site Urls
        if (graphProps.site) {
            dependentCalls.push(
                request.website.siteUrls(graphProps.site.accountId, ["HUB", "WC", "BC", "7BS", "7WAYS"])
            );
        } else {
            dependentCalls.push(Promise.resolve(null));
        }

        // adPixel
        if (graphProps.site && accountId) {
            dependentCalls.push(request.insights.pixel(accountId, {site_id}));
        } else {
            dependentCalls.push(Promise.resolve({}));
        }

        const [pagePropsResult, sitesPropsResult, adPixelResult] = await Promise.all(dependentCalls);
        console.timeEnd('dependent-api-calls');

        pageProps = pagePropsResult;
        sitesProps = sitesPropsResult; // site URLs
        const adPixel = adPixelResult;

        // console.log('pageProps:', pageProps);

        console.time('authentication');
        let reload = {reload: false};
        let contact_user = false;
        let downline_user = false;

        // Check for contact user cookie (parse once)
        let contact_check = authenticator.getTokenCookie(sessionName);
        let contact_check_obj = parseSessionCookie(contact_check);

        if (contact_check_obj) {
            contact_user = contact_check_obj.auth?.site_user || false;
            downline_user = contact_check_obj.auth?.site_downline || false;
        }

        // Handle contact user authentication
        if (contact_user) {
            if (authenticator.env.CONTACT_ALLOWED == 1) {
                authProps = contact_check_obj || authenticator.setUnauthenticationSession(true);
            } else {
                authProps = authenticator.setUnauthenticationSession(true);
            }
        } else {
            // Handle regular authentication
            if (authenticator.verifyToken(token)) {
                // Token exists from auth server
                authenticator.setSessionCookie(true, sessionName);
                /*
                cookie = authenticator.getTokenCookie(sessionName);
                authProps = parseSessionCookie(cookie) || authenticator.setAuthenticationSession(); // set initial authentication cookie if token returns false
                */
                authProps = JSON.parse(
                    JSON.stringify(authenticator.authenticatedObject)
                );
            } else {
                // No valid token - check auth user
                try {
                    const authInfo = await authenticator.checkAuthUser(req);
                    
                    if (authInfo?.token) {
                        // New authentication successful
                        // authenticator.setTokenCookie(authInfo.user_id, 'user_id');
                        const existingUserId = authenticator.getTokenCookie('user_id');
                        if (authInfo.user_id &&
                            String(existingUserId) !== String(authInfo.user_id)) {
                            const expiry = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
                            authenticator.setTokenCookie(
                                authInfo.user_id, 'user_id', true, false, 'lax', expiry
                            );
                        }
                        authenticator.setTokenCookie(authInfo.contact_id, 'contact_id');
                        authenticator.setSessionCookie(true, process.env.AUTH_SERVER_SESSION_NAME);

                        /*
                        cookie = authenticator.getTokenCookie(sessionName);
                        authProps = parseSessionCookie(cookie) || authenticator.setAuthenticationSession(); // set initial authentication cookie if token returns false
                        */
                        authProps = JSON.parse(
                            JSON.stringify(authenticator.authenticatedObject)
                        );

                        if (!authProps.auth?.isAuthenticated) {
                            reload = {
                                reload: {
                                    reload: true,
                                }
                            };
                        }
                    } else {
                        // No new auth - check existing session
                        cookie = authenticator.getTokenCookie(sessionName);
                        authProps = parseSessionCookie(cookie) || authenticator.setAuthenticationSession(); // set initial authentication cookie if token returns false

                        if (authProps.auth?.isAuthenticated) {
                            // Authenticated user - try auto-login
                            authProps = await handleAuthenticatedAutoLogin(
                                authenticator,
                                authProps,
                                graphProps,
                                sessionName
                            );
                        } else {
                            // Unauthenticated - try main domain auto-login
                            const autoLoginResult = await handleUnauthenticatedAutoLogin(
                                authenticator,
                                graphProps,
                                sessionName
                            );
                            
                            authProps = autoLoginResult.authProps;
                            if (autoLoginResult.reload) {
                                reload = autoLoginResult.reload;
                            }
                        }
                    }
                } catch (authError) {
                    console.error("Error in authentication flow:", authError);
                    authProps = authenticator.setAuthenticationSession();
                }
            }
        }
        console.timeEnd('authentication');

        // Get default country
        let country = 'us';
        const countryCookie = authenticator.getTokenCookie('country');
        if (countryCookie === "ca") {
            country = countryCookie;
        }

        // Ensure authProps is properly initialized
        authProps = ensureAuthProps(authProps);

        // Combine all props
        props = {
            ...props,
            ...graphProps,
            ...pageProps,
            ...authProps,
            ...metaData,
            ...reload,
            defaultCountryCode: countryCode,
            sites: sitesProps,
            adPixel: adPixel,
            country: country
        };

        console.log("initialProps:", props);

        if (typeof props.err !== "undefined") {
            res.statusCode = props.err.code;
        }

        return props;

    } catch (error) {
        console.error("Critical error in initialProps:", error);
        
        // Create minimal props with error information
        props = {
            ...props,
            auth: {
                isAuthenticated: false,
                site_owner: false,
                site_user: false,
                userId: null,
                contactId: null
            },
            err: {
                code: 500,
                message: "Internal server error"
            }
        };

        if (res) {
            res.statusCode = 500;
        }

        return props;
    }
}

// Helper function for authenticated user auto-login
async function handleAuthenticatedAutoLogin(authenticator, authProps, graphProps, sessionName) {
    const ref = await authenticator.autoCheckSession(
        authProps.auth.site_domain,
        authProps.auth.site_user_email
    );

    if (typeof ref !== 'undefined' && ref !== false) {
        const data = {
            domain: graphProps.site.url,
            ref: Buffer.from(ref, "base64").toString(),
            websiteId: graphProps.site.websiteId,
        };

        const _response = await authenticator.autoLogin(data);

        if (typeof _response === 'object' && _response.code === 200) {
            const cookie = authenticator.getTokenCookie(sessionName);
            return parseSessionCookie(cookie) || authenticator.setAuthenticationSession();
        } else {
            // Auto-login failed - clear session
            authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
            authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
            return authenticator.setUnauthenticationSession();
        }
    } else {
        // No valid ref - clear session
        authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
        authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
        return authenticator.setUnauthenticationSession();
    }
}

// Helper function for unauthenticated user auto-login
async function handleUnauthenticatedAutoLogin(authenticator, graphProps, sessionName) {
    const ref = await authenticator.autoCheckSessionMainDomain();

    if (typeof ref !== 'undefined' && ref !== false) {
        const data = {
            domain: graphProps.site.url,
            ref: Buffer.from(ref, "base64").toString(),
            websiteId: graphProps.site.websiteId,
        };

        const _response = await authenticator.autoLogin(data);

        if (typeof _response === 'object' && _response.code === 200) {
            const reload = {
                reload: {
                    reload: true,
                    refHash: Buffer.from(ref, "base64").toString()
                }
            };

            authenticator.setTokenCookie(_response.token, process.env.AUTH_SERVER_COOKIE_NAME);
            authenticator.setSessionCookie(true, process.env.AUTH_SERVER_SESSION_NAME);
            const cookie = authenticator.getTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);

            return {
                authProps: parseSessionCookie(cookie) || authenticator.setAuthenticationSession(),
                reload: reload
            };
        } else {
            // Auto-login failed - clear session
            authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
            authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
            return {
                authProps: authenticator.setUnauthenticationSession(),
                reload: null
            };
        }
    } else {
        // No valid ref - clear session
        authenticator.removeTokenCookie(process.env.AUTH_SERVER_COOKIE_NAME);
        authenticator.removeTokenCookie(process.env.AUTH_SERVER_SESSION_NAME);
        return {
            authProps: authenticator.setUnauthenticationSession(),
            reload: null
        };
    }
}

async function categoryProps(req, res, query)
{
    let request = new Request(process.env.apiDomain)

    let props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let category = await request.content.category("wellness-center", query.slug)

    if (typeof category.err !== "undefined")
    {
        props.err = category.err
        res.statusCode = props.err.code
    }

    props.category = category

    return props
}

async function articleProps(req, res, query)
{
    
    let request = new Request(process.env.apiDomain)

    var props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let article = await request.content.article(query.slug,props.site.accountId,props.country)

    if (typeof article.err !== "undefined")
    {
        props.err = article.err
        res.statusCode = props.err.code
    }

    props.article = article

    return props
}

async function newsletterProps(req, res, query)
{
    let request = new Request(process.env.apiDomain)

    var props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let newsletters = await request.ems.newsletters(props.site.accountId)

    if (typeof newsletters.err !== "undefined")
    {
        props.err = newsletters.err
        res.statusCode = props.err.code
    }

    props.newsletters = newsletters

    return props
}

async function newsletterDetailsProps(req, res, query)
{
    let request = new Request(process.env.apiDomain)

    var props = await initialProps(req, res, query)

    if (typeof props.err !== "undefined")
        return props

    let newsletterDetails = await request.ems.newsletterDetails(parseInt(query.slug))

    if (typeof newsletterDetails.err !== "undefined")
    {
        props.err = newsletterDetails.err
        res.statusCode = props.err.code
    }

    props.newslettersDetails = newsletterDetails

    return props
}

export { initialProps, categoryProps, articleProps, newsletterProps, newsletterDetailsProps }
